var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".role-wizard[data-v-e6690ed2] {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.steps-nav[data-v-e6690ed2] {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n  padding: 20px 24px 0;\n  background: #fff;\n  list-style: none;\n  margin: 0;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.step[data-v-e6690ed2] {\n  border-top: 4px solid #e9ecef;\n  padding-top: 14px;\n  cursor: pointer;\n}\n\n.step p[data-v-e6690ed2] {\n  margin: 0;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.25;\n  color: #6b7280;\n  text-align: center;\n}\n\n.step.completed[data-v-e6690ed2] {\n  border-top-color: #2c7be5;\n}\n\n.step.completed p[data-v-e6690ed2] {\n  color: #344053;\n}\n\n.step.active[data-v-e6690ed2] {\n  border-top-color: #2c7be5;\n}\n\n.step.active p[data-v-e6690ed2] {\n  color: #2c7be5;\n}\n\n/* Content */\n.wizard-content[data-v-e6690ed2] {\n  padding: 32px;\n  min-height: 500px;\n}\n\n.step-content[data-v-e6690ed2] {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.step-title[data-v-e6690ed2] {\n  font-size: 18px;\n  font-weight: 600;\n  color: #212529;\n  margin-bottom: 6px;\n}\n\n.step-description[data-v-e6690ed2] {\n  color: #6c757d;\n  font-size: 14px;\n  margin-bottom: 30px;\n}\n\n.search-list-container[data-v-e6690ed2] {\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  background: #ffffff;\n  overflow: hidden;\n}\n\n.search-box[data-v-e6690ed2] {\n  padding: 16px;\n  border-bottom: 1px solid #eaecf0;\n}\n\n.search-box input[data-v-e6690ed2] {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  background: #ffffff;\n}\n\n.select-all-section[data-v-e6690ed2] {\n  padding: 16px;\n  background: #f9fafb;\n  border-bottom: 1px solid #eaecf0;\n}\n\n.services-list[data-v-e6690ed2],\n.permissions-groups[data-v-e6690ed2],\n.merchants-list[data-v-e6690ed2] {\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 16px;\n}\n\n.service-item[data-v-e6690ed2],\n.permission-item[data-v-e6690ed2],\n.merchant-item[data-v-e6690ed2] {\n  padding: 12px 0;\n  border-bottom: 1px solid #f1f3f4;\n}\n\n.service-item[data-v-e6690ed2]:last-child,\n.permission-item[data-v-e6690ed2]:last-child,\n.merchant-item[data-v-e6690ed2]:last-child {\n  border-bottom: none;\n}\n\n.permission-group[data-v-e6690ed2] {\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  overflow: hidden;\n}\n\n.group-header[data-v-e6690ed2] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 18px;\n  background: #f8f9fa;\n  cursor: pointer;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.group-header[data-v-e6690ed2]:hover {\n  background: #e9edf3;\n}\n\n.group-label[data-v-e6690ed2] {\n  font-weight: 500;\n  margin-bottom: 0;\n}\n\n.group-toggle[data-v-e6690ed2] {\n  transition: transform 0.2s ease;\n  color: #6c757d;\n}\n\n.group-toggle.expanded[data-v-e6690ed2] {\n  transform: rotate(180deg);\n}\n\n.group-permissions[data-v-e6690ed2] {\n  padding: 16px;\n}\n\n.wizard-footer[data-v-e6690ed2] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 32px;\n  border-top: 1px solid #e9ecef;\n  background: #f8f9fa;\n}\n\n.footer-actions[data-v-e6690ed2] {\n  display: flex;\n  gap: 12px;\n}\n\n.btn[data-v-e6690ed2] {\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n}\n\n.btn-default[data-v-e6690ed2] {\n  background: #6c757d;\n  color: white;\n}\n\n.btn-outline-primary[data-v-e6690ed2] {\n  background: transparent;\n  border: 1px solid #2c7be5;\n  color: #2c7be5;\n}\n\n.btn-primary[data-v-e6690ed2] {\n  background: #2c7be5;\n  color: white;\n}\n\n.btn[data-v-e6690ed2]:hover {\n  opacity: 0.9;\n}\n\n.btn[data-v-e6690ed2]:disabled,\n.btn.btn-disabled[data-v-e6690ed2] {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: #6c757d !important;\n  color: white !important;\n}\n\n.btn[data-v-e6690ed2]:disabled:hover,\n.btn.btn-disabled[data-v-e6690ed2]:hover {\n  opacity: 0.5;\n}\n\n.form-group[data-v-e6690ed2] {\n  margin-bottom: 1.5rem;\n}\n\n.label-on-left[data-v-e6690ed2] {\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 0.5rem;\n  display: block;\n}\n\n.label-on-left.required[data-v-e6690ed2]::after {\n  content: ' *';\n  color: #dc3545;\n}\n\n.form-control[data-v-e6690ed2] {\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  padding: 0.75rem;\n  width: 100%;\n  display: block;\n}\n\n.form-control[data-v-e6690ed2]:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  outline: none;\n}\n\n.custom-control[data-v-e6690ed2] {\n  position: relative;\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 2rem;\n}\n\n.custom-control-input[data-v-e6690ed2] {\n  position: absolute;\n  left: 0;\n  z-index: -1;\n  width: 1.2rem;\n  height: 1.2rem;\n  opacity: 0;\n}\n\n.custom-control-label[data-v-e6690ed2] {\n  position: relative;\n  margin-bottom: 0;\n  vertical-align: top;\n  font-size: 16px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n}\n\n.custom-control-label[data-v-e6690ed2]::before {\n  position: absolute;\n  top: 0.1rem;\n  left: -2rem;\n  display: block;\n  width: 1.2rem;\n  height: 1.2rem;\n  pointer-events: none;\n  content: \"\";\n  background-color: #fff;\n  border: 2px solid #d1d5db;\n  border-radius: 0.375rem;\n}\n\n.custom-control-input:checked~.custom-control-label[data-v-e6690ed2]::before {\n  border-color: #2563eb;\n  background-color: #2563eb;\n}\n\n.custom-control-input:checked~.custom-control-label[data-v-e6690ed2]::after {\n  position: absolute;\n  top: 0.1rem;\n  left: -2rem;\n  display: block;\n  width: 1.2rem;\n  height: 1.2rem;\n  content: \"\";\n  background: no-repeat center/60% 60%;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3e%3cpath fill='%23ffffff' d='M10.28 2.28L5 7.56l-2.28-2.28a.75.75 0 00-1.06 1.06L4.47 9.15a.75.75 0 001.06 0l6.81-6.81a.75.75 0 00-1.06-1.06z'/%3e%3c/svg%3e\");\n}\n\n.custom-control-input[type=\"radio\"]~.custom-control-label[data-v-e6690ed2]::before {\n  border-radius: 50% !important;\n  border: 2px solid #d1d5db !important;\n  background-color: #fff !important;\n}\n\n.custom-control-input[type=\"radio\"]:checked~.custom-control-label[data-v-e6690ed2]::before {\n  border-color: #2563eb !important;\n  background-color: #2563eb !important;\n}\n\n.custom-control-input[type=\"radio\"]:checked~.custom-control-label[data-v-e6690ed2]::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='3' fill='%23ffffff'/%3e%3c/svg%3e\") !important;\n  background-size: 50% 50% !important;\n  background-position: center !important;\n}\n\n.custom-control-input:hover~.custom-control-label[data-v-e6690ed2]::before {\n  border-color: #9ca3af;\n}\n\n.custom-control-input:focus~.custom-control-label[data-v-e6690ed2]::before {\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n  border-color: #2563eb;\n}\n\n@media (max-width: 768px) {\n  .wizard-content[data-v-e6690ed2] {\n    padding: 20px;\n  }\n\n  .steps-nav[data-v-e6690ed2] {\n    padding: 16px;\n  }\n\n  .step p[data-v-e6690ed2] {\n    font-size: 14px;\n  }\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["initialRoleName", "initialMerchant", "initialMerchants", "initialServices", "initialPerms", "initialGatewayIds", "permissions", "fetchServicesUrl", "merchantsUrl", "merchantslist", "initialAgency", "gatewayslist"],

  data: function data() {
    return {
      currentStep: 1,
      roleName: "",
      merchantId: null,
      merchantIds: [],
      serviceIds: [],
      gatewayIds: [],
      selectedPerms: [],
      merchants: [],
      ml: [],
      agencyId: null,
      show_merchants_input: true,
      show_agency_input: true,
      show_gateways_input: true,
      availableServices: [],
      availablePermissions: [],
      serviceSearch: '',
      permissionSearch: '',
      merchantSearch: '',
      expandedGroups: ['User Management'],
      originalData: null
    };
  },

  computed: {
    agency: function agency() {
      return this.agencyId;
    },

    filteredMerchants: function filteredMerchants() {
      if (!this.merchantSearch) return this.ml;
      var vm = this;
      return this.ml.filter(function (m) {
        return m.name.toLowerCase().includes(vm.merchantSearch.toLowerCase());
      });
    },

    allMerchantsSelected: function allMerchantsSelected() {
      var vm = this;
      return this.filteredMerchants.length > 0 && this.filteredMerchants.every(function (m) {
        return vm.merchantIds.indexOf(m.id) !== -1;
      });
    },

    filteredServices: function filteredServices() {
      if (!this.serviceSearch) return this.availableServices;
      var vm = this;
      return this.availableServices.filter(function (s) {
        return s.name.toLowerCase().includes(vm.serviceSearch.toLowerCase());
      });
    },

    allServicesSelected: function allServicesSelected() {
      var vm = this;
      return this.filteredServices.length > 0 && this.filteredServices.every(function (s) {
        return vm.serviceIds.indexOf(s.id) !== -1;
      });
    },

    filteredPermissionGroups: function filteredPermissionGroups() {
      if (!this.permissionSearch) return this.permissionGroups;
      return this.permissionGroups.map(function (group) {
        return (0, _assign2.default)({}, group, {
          permissions: group.permissions.filter(function (p) {
            return p.label.toLowerCase().includes(this.permissionSearch.toLowerCase());
          }.bind(this))
        });
      }.bind(this)).filter(function (group) {
        return group.permissions.length > 0;
      });
    },

    permissionGroups: function permissionGroups() {
      var groups = {};
      var vm = this;
      (this.availablePermissions || []).forEach(function (perm) {
        var category = vm.getPermissionCategory(perm.label);
        if (!groups[category]) {
          groups[category] = { name: category, permissions: [] };
        }
        groups[category].permissions.push(perm);
      });
      return (0, _values2.default)(groups);
    },

    allPermissionsSelected: function allPermissionsSelected() {
      var allPermIds = [];
      this.permissionGroups.forEach(function (g) {
        g.permissions.forEach(function (p) {
          allPermIds.push(p.value);
        });
      });
      var vm = this;
      return allPermIds.length > 0 && allPermIds.every(function (id) {
        return vm.selectedPerms.indexOf(id) !== -1;
      });
    },

    hasFormChanged: function hasFormChanged() {
      if (!this.originalData) return false;

      var arraysEqual = function arraysEqual(a, b) {
        if (!a && !b) return true;
        if (!a || !b) return false;
        if (a.length !== b.length) return false;
        var aSorted = a.slice().sort();
        var bSorted = b.slice().sort();
        return aSorted.every(function (val, i) {
          return val === bSorted[i];
        });
      };

      return this.roleName !== this.originalData.roleName || this.merchantId !== this.originalData.merchantId || !arraysEqual(this.merchantIds, this.originalData.merchantIds) || !arraysEqual(this.serviceIds, this.originalData.serviceIds) || !arraysEqual(this.selectedPerms, this.originalData.selectedPerms) || !arraysEqual(this.gatewayIds, this.originalData.gatewayIds);
    }
  },

  methods: {
    initializeData: function initializeData() {
      this.roleName = this.initialRoleName || "";
      this.merchantId = this.initialMerchant || null;
      this.agencyId = this.initialAgency || null;
      this.ml = this.merchantslist || [];

      this.merchantIds = this.parseArrayProp(this.initialMerchants);
      this.serviceIds = this.parseArrayProp(this.initialServices);
      this.selectedPerms = this.parseArrayProp(this.initialPerms);
      this.gatewayIds = this.parseArrayProp(this.initialGatewayIds);

      this.originalData = {
        roleName: this.roleName,
        merchantId: this.merchantId,
        merchantIds: this.merchantIds.slice(),
        serviceIds: this.serviceIds.slice(),
        selectedPerms: this.selectedPerms.slice(),
        gatewayIds: this.gatewayIds.slice()
      };

      this.setupPermissions();
    },

    parseArrayProp: function parseArrayProp(prop) {
      if (!prop) return [];
      if (Array.isArray(prop)) return prop.slice();
      if (typeof prop === 'string') {
        try {
          var parsed = JSON.parse(prop);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      return [];
    },

    setupPermissions: function setupPermissions() {
      if (this.merchantId === "none" || !this.merchantId) {
        if (this.permissions) {
          this.availablePermissions = this.permissions.admin.concat(this.permissions.basic);
        }
      } else if (this.merchantId) {
        if (this.permissions) {
          this.availablePermissions = this.permissions.basic;
        }
      }
    },

    goToStep: function goToStep(step) {
      this.currentStep = step;
    },

    nextStep: function nextStep(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (this.currentStep < 3) {
        this.currentStep++;
      }
    },

    previousStep: function previousStep(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },

    submitForm: function submitForm(event) {
      if (event) {
        event.preventDefault();
      }

      if (!this.hasFormChanged) {
        return;
      }

      var parentForm = document.getElementById('roleForm');
      if (!parentForm) {
        console.error('Parent form not found');
        return;
      }

      var csrfToken = null;
      var csrfInput = parentForm.querySelector('input[name="_csrf_token"]');
      if (csrfInput) {
        csrfToken = csrfInput.value;
      } else {
        var csrfMeta = document.querySelector('meta[name="csrf-token"]');
        if (csrfMeta) {
          csrfToken = csrfMeta.getAttribute('content');
        }
      }

      if (!csrfToken) {
        console.error('CSRF token not found');
        return;
      }

      var form = document.createElement('form');
      form.method = 'POST';
      form.action = parentForm.action;

      var csrfHiddenInput = document.createElement('input');
      csrfHiddenInput.type = 'hidden';
      csrfHiddenInput.name = '_csrf_token';
      csrfHiddenInput.value = csrfToken;
      form.appendChild(csrfHiddenInput);

      var isUpdate = parentForm.action.includes('/edit') || parentForm.querySelector('input[name="_method"]');
      if (isUpdate) {
        var methodInput = document.createElement('input');
        methodInput.type = 'hidden';
        methodInput.name = '_method';
        methodInput.value = 'put';
        form.appendChild(methodInput);
      }

      this.addHiddenInput(form, 'role[name]', this.roleName);
      this.addHiddenInput(form, 'role[merchant_id]', this.merchantId === 'none' ? '' : this.merchantId);
      this.addHiddenInput(form, 'role[agency_id]', this.agencyId || '');

      if (!this.arraysEqual(this.merchantIds, this.originalData.merchantIds)) {
        (this.merchantIds || []).forEach(function (id) {
          if (id && id !== '' && id !== 'none') {
            this.addHiddenInput(form, 'role[merchant_ids][]', id);
          }
        }.bind(this));
      }

      if (!this.arraysEqual(this.serviceIds, this.originalData.serviceIds)) {
        (this.serviceIds || []).forEach(function (id) {
          if (id && id !== '' && id !== 'none') {
            this.addHiddenInput(form, 'role[service_ids][]', id);
          }
        }.bind(this));
      }

      if (!this.arraysEqual(this.selectedPerms, this.originalData.selectedPerms)) {
        (this.selectedPerms || []).forEach(function (id) {
          if (id && id !== '' && id !== 'none') {
            this.addHiddenInput(form, 'role[permission_ids][]', id);
          }
        }.bind(this));
      }

      if (!this.arraysEqual(this.gatewayIds, this.originalData.gatewayIds)) {
        (this.gatewayIds || []).forEach(function (id) {
          if (id && id !== '' && id !== 'none') {
            this.addHiddenInput(form, 'role[gateway_ids][]', id);
          }
        }.bind(this));
      }

      document.body.appendChild(form);
      form.submit();
    },

    arraysEqual: function arraysEqual(a, b) {
      if (!a && !b) return true;
      if (!a || !b) return false;
      if (a.length !== b.length) return false;
      var aSorted = a.slice().sort();
      var bSorted = b.slice().sort();
      return aSorted.every(function (val, i) {
        return val === bSorted[i];
      });
    },

    addHiddenInput: function addHiddenInput(form, name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value || '';
      form.appendChild(input);
    },

    onMerchantChange: function onMerchantChange(evt) {

      if (!this.originalData || !this.originalData.serviceIds.length && !this.originalData.selectedPerms.length) {
        this.availableServices = [];
        this.selectedPerms = [];
      }

      if (this.merchantId === "none") {
        this.merchantIds = this.ml.map(function (m) {
          return m.id;
        });
      }

      this.loadServicesForMerchants();
      this.setupPermissions();

      if (this.merchantId !== "none") {
        this.show_agency_input = false;
        this.show_gateways_input = false;
      }
    },

    onMerchantsChange: function onMerchantsChange(evt) {
      this.loadServicesForMerchants();
    },

    loadServicesForMerchants: function loadServicesForMerchants() {
      var selectedMerchantIds = null;

      if (this.merchantId == "none") {
        selectedMerchantIds = this.merchantIds;
      } else if (!!this.merchantId) {
        selectedMerchantIds = [this.merchantId];
      }

      if (selectedMerchantIds && selectedMerchantIds.length > 0) {
        selectedMerchantIds = encodeURIComponent((0, _stringify2.default)(selectedMerchantIds));
        $.getJSON(this.fetchServicesUrl.replace("merchant_ids", selectedMerchantIds), function (data) {
          this.availableServices = data;
        }.bind(this));
      }
    },

    toggleAllMerchants: function toggleAllMerchants() {
      if (this.allMerchantsSelected) {
        this.merchantIds = [];
      } else {
        var vm = this;
        this.merchantIds = this.filteredMerchants.map(function (m) {
          return m.id;
        });
      }
      this.onMerchantsChange();
    },

    toggleAllServices: function toggleAllServices() {
      if (this.allServicesSelected) {
        this.serviceIds = [];
      } else {
        var vm = this;
        this.serviceIds = this.filteredServices.map(function (s) {
          return s.id;
        });
      }
    },

    toggleAllPermissions: function toggleAllPermissions() {
      var allPermIds = [];
      this.permissionGroups.forEach(function (g) {
        g.permissions.forEach(function (p) {
          allPermIds.push(p.value);
        });
      });

      if (this.allPermissionsSelected) {
        this.selectedPerms = [];
      } else {
        this.selectedPerms = allPermIds.slice();
      }
    },

    toggleGroup: function toggleGroup(groupName) {
      var index = this.expandedGroups.indexOf(groupName);
      if (index > -1) {
        this.expandedGroups.splice(index, 1);
      } else {
        this.expandedGroups.push(groupName);
      }
    },

    isGroupSelected: function isGroupSelected(group) {
      var vm = this;
      return group.permissions.length > 0 && group.permissions.every(function (p) {
        return vm.selectedPerms.indexOf(p.value) !== -1;
      });
    },

    toggleGroupPermissions: function toggleGroupPermissions(group) {
      var groupPermIds = group.permissions.map(function (p) {
        return p.value;
      });
      var allSelected = this.isGroupSelected(group);

      if (allSelected) {
        var vm = this;
        this.selectedPerms = this.selectedPerms.filter(function (id) {
          return groupPermIds.indexOf(id) === -1;
        });
      } else {
        var newPerms = groupPermIds.filter(function (id) {
          return this.selectedPerms.indexOf(id) === -1;
        }.bind(this));
        this.selectedPerms = this.selectedPerms.concat(newPerms);
      }
    },

    getPermissionCategory: function getPermissionCategory(label) {
      var lowerLabel = label.toLowerCase();
      if (lowerLabel.includes('user') || lowerLabel.includes('role')) {
        return 'User Management';
      } else if (lowerLabel.includes('invoice')) {
        return 'Invoice Management';
      } else if (lowerLabel.includes('payment')) {
        return 'Payment Management';
      } else {
        return 'General';
      }
    }
  },

  created: function created() {
    this.initializeData();
    this.loadServicesForMerchants();
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"role-wizard"},[_c('ul',{staticClass:"steps-nav"},[_c('li',{staticClass:"step",class:{ completed: _vm.currentStep > 1, active: _vm.currentStep === 1 },on:{"click":function($event){return _vm.goToStep(1)}}},[_c('p',[_vm._v("Basic Details")])]),_vm._v(" "),_c('li',{staticClass:"step",class:{ completed: _vm.currentStep > 2, active: _vm.currentStep === 2 },on:{"click":function($event){return _vm.goToStep(2)}}},[_c('p',[_vm._v("Services")])]),_vm._v(" "),_c('li',{staticClass:"step",class:{ active: _vm.currentStep === 3 },on:{"click":function($event){return _vm.goToStep(3)}}},[_c('p',[_vm._v("Permissions")])])]),_vm._v(" "),_c('div',{staticClass:"wizard-content"},[(_vm.currentStep === 1)?_c('div',{staticClass:"step-content"},[_c('h3',{staticClass:"step-title"},[_vm._v("Basic Details")]),_vm._v(" "),_c('p',{staticClass:"step-description"},[_vm._v("Set up the basic information for this role")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-on-left required"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"is-empty"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.roleName),expression:"roleName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.roleName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.roleName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-on-left required"},[_vm._v("Merchant (role belongs to)")]),_vm._v(" "),_c('div',{staticClass:"search-list-container"},[_c('div',{staticClass:"search-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchantSearch),expression:"merchantSearch"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Search merchants..."},domProps:{"value":(_vm.merchantSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.merchantSearch=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"merchants-list"},[_vm._l((_vm.filteredMerchants),function(merchant){return _c('div',{key:'main-' + merchant.id,staticClass:"merchant-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchantId),expression:"merchantId"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":'main-merchant-' + merchant.id},domProps:{"value":merchant.id,"checked":_vm._q(_vm.merchantId,merchant.id)},on:{"change":[function($event){_vm.merchantId=merchant.id},_vm.onMerchantChange]}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":'main-merchant-' + merchant.id}},[_vm._v(_vm._s(merchant.name))])])])}),_vm._v(" "),_c('div',{staticClass:"merchant-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchantId),expression:"merchantId"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"merchant-none","value":"none"},domProps:{"checked":_vm._q(_vm.merchantId,"none")},on:{"change":[function($event){_vm.merchantId="none"},_vm.onMerchantChange]}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"merchant-none"}},[_vm._v("None")])])])],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.merchantId == 'none'),expression:"merchantId == 'none'"}],staticClass:"form-group"},[_c('label',{staticClass:"label-on-left"},[_vm._v("Merchants (role applies to)")]),_vm._v(" "),_c('div',{staticClass:"search-list-container"},[_c('div',{staticClass:"search-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchantSearch),expression:"merchantSearch"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Search merchants..."},domProps:{"value":(_vm.merchantSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.merchantSearch=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"select-all-section"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"select-all-merchants"},domProps:{"checked":_vm.allMerchantsSelected},on:{"change":_vm.toggleAllMerchants}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"select-all-merchants"}},[_vm._v("Select All")])])]),_vm._v(" "),_c('div',{staticClass:"merchants-list"},_vm._l((_vm.filteredMerchants),function(merchant){return _c('div',{key:merchant.id,staticClass:"merchant-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchantIds),expression:"merchantIds"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":'merchant-' + merchant.id},domProps:{"value":merchant.id,"checked":Array.isArray(_vm.merchantIds)?_vm._i(_vm.merchantIds,merchant.id)>-1:(_vm.merchantIds)},on:{"change":[function($event){var $$a=_vm.merchantIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=merchant.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.merchantIds=$$a.concat([$$v]))}else{$$i>-1&&(_vm.merchantIds=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.merchantIds=$$c}},_vm.onMerchantsChange]}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":'merchant-' + merchant.id}},[_vm._v(_vm._s(merchant.name))])])])}),0)])])]):_vm._e(),_vm._v(" "),(_vm.currentStep === 2)?_c('div',{staticClass:"step-content"},[_c('h3',{staticClass:"step-title"},[_vm._v("Services")]),_vm._v(" "),_c('p',{staticClass:"step-description"},[_vm._v("Select services this role should have access to")]),_vm._v(" "),_c('div',{staticClass:"search-list-container"},[_c('div',{staticClass:"search-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.serviceSearch),expression:"serviceSearch"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Search services..."},domProps:{"value":(_vm.serviceSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.serviceSearch=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"select-all-section"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"select-all-services"},domProps:{"checked":_vm.allServicesSelected},on:{"change":_vm.toggleAllServices}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"select-all-services"}},[_vm._v("Select All")])])]),_vm._v(" "),_c('div',{staticClass:"services-list"},_vm._l((_vm.filteredServices),function(service){return _c('div',{key:service.id,staticClass:"service-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.serviceIds),expression:"serviceIds"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":'service-' + service.id},domProps:{"value":service.id,"checked":Array.isArray(_vm.serviceIds)?_vm._i(_vm.serviceIds,service.id)>-1:(_vm.serviceIds)},on:{"change":function($event){var $$a=_vm.serviceIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=service.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.serviceIds=$$a.concat([$$v]))}else{$$i>-1&&(_vm.serviceIds=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.serviceIds=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":'service-' + service.id}},[_vm._v(_vm._s(service.name))])])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.currentStep === 3)?_c('div',{staticClass:"step-content"},[_c('h3',{staticClass:"step-title"},[_vm._v("Permissions")]),_vm._v(" "),_c('p',{staticClass:"step-description"},[_vm._v("These permissions will be applied to every user with this role")]),_vm._v(" "),_c('div',{staticClass:"search-list-container"},[_c('div',{staticClass:"search-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.permissionSearch),expression:"permissionSearch"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Search permissions..."},domProps:{"value":(_vm.permissionSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.permissionSearch=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"select-all-section"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"select-all-permissions"},domProps:{"checked":_vm.allPermissionsSelected},on:{"change":_vm.toggleAllPermissions}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"select-all-permissions"}},[_vm._v("Select All")])])]),_vm._v(" "),_c('div',{staticClass:"permissions-groups"},_vm._l((_vm.filteredPermissionGroups),function(group){return _c('div',{key:group.name,staticClass:"permission-group"},[_c('div',{staticClass:"group-header",on:{"click":function($event){return _vm.toggleGroup(group.name)}}},[_c('div',{staticClass:"custom-control custom-checkbox",on:{"click":function($event){$event.stopPropagation();}}},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":'group-' + group.name},domProps:{"checked":_vm.isGroupSelected(group)},on:{"change":function($event){return _vm.toggleGroupPermissions(group)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label group-label",attrs:{"for":'group-' + group.name}},[_vm._v(_vm._s(group.name))])]),_vm._v(" "),_c('i',{staticClass:"fa fa-chevron-down group-toggle",class:{ expanded: _vm.expandedGroups.includes(group.name) }})]),_vm._v(" "),(_vm.expandedGroups.includes(group.name))?_c('div',{staticClass:"group-permissions"},_vm._l((group.permissions),function(permission){return _c('div',{key:permission.value,staticClass:"permission-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPerms),expression:"selectedPerms"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":'perm-' + permission.value},domProps:{"value":permission.value,"checked":Array.isArray(_vm.selectedPerms)?_vm._i(_vm.selectedPerms,permission.value)>-1:(_vm.selectedPerms)},on:{"change":function($event){var $$a=_vm.selectedPerms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=permission.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedPerms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedPerms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedPerms=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":'perm-' + permission.value}},[_vm._v(_vm._s(permission.label))])])])}),0):_vm._e()])}),0)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"wizard-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","onclick":"history.back()"}},[_vm._v("Cancel")]),_vm._v(" "),_c('div',{staticClass:"footer-actions"},[(_vm.currentStep > 1)?_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.previousStep}},[_vm._v("Previous")]):_vm._e(),_vm._v(" "),(_vm.currentStep < 3)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.nextStep}},[_vm._v("Next")]):_c('button',{staticClass:"btn btn-primary",class:{ 'btn-disabled': !_vm.hasFormChanged },attrs:{"type":"submit","disabled":!_vm.hasFormChanged},on:{"click":_vm.submitForm}},[_vm._v("\n        "+_vm._s(_vm.hasFormChanged ? 'Save' : 'No Changes')+"\n      ")])])])])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-e6690ed2"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e6690ed2", __vue__options__)
  } else {
    hotAPI.reload("data-v-e6690ed2", __vue__options__)
  }
})()}